import api from "./apiService";

let cachedData = null;
let lastFetched = null;

const CACHE_DURATION_MS = 3 * 60 * 1000; // 3 minutes

const filterService = {
  fetchFilters: async () => {
    const now = Date.now();

    // If cached and still valid, return it
    if (cachedData && lastFetched && now - lastFetched < CACHE_DURATION_MS) {
      return cachedData;
    }

    // Else, fetch fresh data
    const response = await api.get("/EmployeeManagement/GetAdminFilters");
    cachedData = response.data.data;
    lastFetched = now;

    return cachedData;
  },
};

export default filterService;
